import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";
import { AssetTypeDto } from "src/store/asset-types/type";
import { updateDamageDefinition } from "src/store/contract-damage-definition/saga";
import { DamageDefinitionDetailDto } from "src/store/contract-damage-definition/type";
import { getDataTypes } from "src/store/system/saga";
import { DataTypeDto } from "src/store/system/type";
import * as Yup from "yup";

const ContractDamageDefinitionEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: DamageDefinitionDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [assettypes, setAssettypes] = useState<AssetTypeDto[]>([]);
  const [datatypes, setDatatypes] = useState<DataTypeDto[]>([]);
  useEffect(() => {
    if (open) {
      dispatch(
        getDataTypes({
          payload: {
            onSuccess: (message, payload) => {
              setDatatypes(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssettypes(payload);
            },
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.DamageDefinition.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          DataTypeId: data.DataTypeId,
          AssetTypeId: data.AssetTypeId,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Title: x.Name,
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateDamageDefinition({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          AssetTypeId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DataTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Contract.DamageDefinition.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "AssetTypeId",
            label: t("Contract.DamageDefinition.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assettypes,
            },
          },
          {
            field: "DataTypeId",
            label: t("Contract.DamageDefinition.DataType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: datatypes,
            },
            onDisabilityChange: () => true,
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ContractDamageDefinitionEditForm;
